import { useQueryApi } from 'utils/api'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'

const API_KS_PATH = '/guru-ks/v1/ks'

export function useAPIGetKepalaSekolahEligibility() {
  return useQueryApi<IBCKSKepalaSekolahEligibility>(
    `${API_KS_PATH}/eligibility`,
    {
      queryConfig: {
        useErrorBoundary: false,
      },
    }
  )
}
